(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-tailwind"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 650;
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
    // Change this condition to use your custom threshold
    if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > scrollThreshold) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= scrollThreshold) { // Update this condition too
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let teardown = null;

    function init() {
      if (teardown) teardown();

      const nav = document.querySelector('[data-tl-nav]');
      if (!nav) return;

      const isSticky = nav.hasAttribute('data-tl-sticky');
      const extraOffset = Number(nav.dataset.tlOffset) || 0;
      const list = nav.querySelector('.tl-nav__list');
      const links = [...nav.querySelectorAll('[data-tl-nav-link]')];
      const sections = links
        .map((link) => ({ link, el: document.getElementById(link.dataset.tlNavLink) }))
        .filter((s) => s.el);

      // How much of the viewport top is covered by the sticky bar (+ any theme header offset)
      const coveredTop = () => (isSticky ? nav.offsetHeight + extraOffset : 0);

      // Anchor jumps land just below the sticky bar instead of underneath it
      const setScrollPadding = () => {
        document.documentElement.style.scrollPaddingTop = coveredTop() + 8 + 'px';
      };

      let activeLink = null;
      function setActive(link) {
        if (link === activeLink) return;
        activeLink = link;
        links.forEach((l) => {
          const on = l === link;
          l.classList.toggle('is-active', on);
          if (on) l.setAttribute('aria-current', 'location');
          else l.removeAttribute('aria-current');
        });
        // keep the active item visible when the list scrolls sideways (mobile)
        if (link && list && list.scrollWidth > list.clientWidth) {
          list.scrollTo({ left: link.offsetLeft - (list.clientWidth - link.offsetWidth) / 2, behavior: 'smooth' });
        }
      }

      const progressLine = nav.querySelector('[data-tl-nav-progress]');

      function updateProgress() {
        if (!progressLine) return;
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        const progress = scrollable > 0 ? Math.min(Math.max(window.scrollY / scrollable, 0), 1) : 0;
        progressLine.style.width = (progress * 100) + '%';
      }

      // Active = the last section whose top has passed ~30% down the visible area
      function update() {
        updateProgress();
        const line = coveredTop() + window.innerHeight * 0.3;
        let current = null;
        let bestTop = -Infinity;
        sections.forEach((s) => {
          const top = s.el.getBoundingClientRect().top;
          if (top <= line && top > bestTop) { bestTop = top; current = s.link; }
        });
        const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
        if (atBottom && sections.length) current = sections[sections.length - 1].link;
        setActive(current);
      }

      // While a click-initiated smooth scroll runs, don't flicker through the sections in between
      let locked = false;
      let lockTimer;
      const unlock = () => { locked = false; clearTimeout(lockTimer); update(); };

      function onClick(event) {
        const link = event.target.closest('[data-tl-nav-link]');
        if (!link || !nav.contains(link)) return;
        setActive(link);
        locked = true;
        clearTimeout(lockTimer);
        lockTimer = setTimeout(unlock, 1200);
      }

      let ticking = false;
      function onScroll() {
        updateProgress();
        if (locked || ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; update(); });
      }
      function onResize() { setScrollPadding(); update(); }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);
      window.addEventListener('scrollend', unlock);
      nav.addEventListener('click', onClick);

      const ro = 'ResizeObserver' in window ? new ResizeObserver(onResize) : null;
      if (ro) ro.observe(nav);

      setScrollPadding();
      update();

      teardown = () => {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
        window.removeEventListener('scrollend', unlock);
        nav.removeEventListener('click', onClick);
        if (ro) ro.disconnect();
        clearTimeout(lockTimer);
        document.documentElement.style.scrollPaddingTop = '';
      };
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', () => { if (teardown) { teardown(); teardown = null; } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.tl-form');
    if (!form) return;

    const email = form.querySelector('input[type="email"][name="contact[email]"]');
    const confirm = form.querySelector('input[type="email"]:not([name="contact[email]"])');
    if (!email || !confirm) return;

    const errorMsg = form.querySelector('.tl-field__error');

    if (email.value.trim().toLowerCase() !== confirm.value.trim().toLowerCase()) {
      e.preventDefault();
      confirm.classList.add('is-invalid');
      if (errorMsg) errorMsg.style.display = 'block';
      confirm.focus();
    } else {
      confirm.classList.remove('is-invalid');
      if (errorMsg) errorMsg.style.display = 'none';
    }
  });

  document.addEventListener('input', (e) => {
    const input = e.target;
    const form = input.closest('.tl-form');
    if (!form) return;

    const email = form.querySelector('input[type="email"][name="contact[email]"]');
    const confirm = form.querySelector('input[type="email"]:not([name="contact[email]"])');
    const errorMsg = form.querySelector('.tl-field__error');

    if (confirm && (input === email || input === confirm)) {
      if (email.value.trim().toLowerCase() === confirm.value.trim().toLowerCase()) {
        confirm.classList.remove('is-invalid');
        if (errorMsg) errorMsg.style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Smooth ease-out scrolling to form target
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function smoothScrollTo(targetEl, duration = 850) {
      const start = window.pageYOffset;
      const targetPos = targetEl.getBoundingClientRect().top + window.pageYOffset;
      const distance = targetPos - start - 32; // offset from top
      const startTime = performance.now();

      function step(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = easeOutCubic(progress);

        window.scrollTo(0, start + distance * ease);

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          // Focus first interactive element or form
          const input = targetEl.querySelector('input, textarea');
          if (input) input.focus({ preventScroll: true });
        }
      }

      requestAnimationFrame(step);
    }

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tl-scroll-to]');
      if (!btn) return;
      const targetId = btn.getAttribute('data-tl-scroll-to');
      const target = document.getElementById(targetId) || document.querySelector('.tl-card--form') || document.querySelector('.tl-contact');
      if (target) {
        e.preventDefault();
        smoothScrollTo(target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-process"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');

    function setOpen(panel, open) {
      panel.classList.toggle('is-open', open);
      panel.querySelector('[data-tl-panel-toggle]').setAttribute('aria-expanded', String(open));
    }

    /*
      Measure each panel in an off-screen clone (transitions off) to learn
      (a) the open-panel width, used to give the text a fixed width so it doesn't reflow mid-animation
      (b) the tallest panel, used as the row's min-height so the row never jumps between panels.
    */
    function measure(acc) {
      if (mobile.matches) {
        acc.style.removeProperty('--tl-acc-min');
        acc.style.removeProperty('--tl-open-w');
        acc.classList.add('is-ready');
        return;
      }

      // natural (unrotated) size of each title, so CSS can place the vertical version exactly
      acc.querySelectorAll('.tl-panel__label').forEach((label) => {
        label.style.setProperty('--tl-label-w', label.offsetWidth + 'px');
        label.style.setProperty('--tl-label-h', label.offsetHeight + 'px');
      });

      const clone = acc.cloneNode(true);
      clone.classList.remove('is-ready');
      clone.classList.add('is-measuring');
      clone.removeAttribute('data-tl-accordion');
      clone.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
      clone.style.cssText =
        'position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;width:' +
        acc.offsetWidth + 'px;--tl-acc-min:0px;';
      acc.parentNode.insertBefore(clone, acc.nextSibling);

      const panels = [...clone.querySelectorAll(':scope > .tl-panel')];
      let tallest = 0;
      let openWidth = 0;
      panels.forEach((p, i) => {
        panels.forEach((q, j) => q.classList.toggle('is-open', i === j));
        // Ensure height accounts for the title + 180px illustration + bottom icon + margins
        const imgWrap = p.querySelector('.tl-panel__image-wrap');
        const imgBottom = imgWrap ? 28 + 48 + 180 + 70 : 0;
        tallest = Math.max(tallest, clone.offsetHeight, imgBottom);
        openWidth = p.offsetWidth;
      });
      clone.remove();

      if (panels.length) {
        acc.style.setProperty('--tl-acc-min', Math.ceil(tallest) + 12 + 'px');
        acc.style.setProperty('--tl-open-w', Math.floor(openWidth) + 'px');
      }
      acc.classList.add('is-ready');
    }

    const measureAll = () => document.querySelectorAll('[data-tl-accordion]').forEach(measure);

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-tl-panel-toggle]');
      if (!btn) return;
      const panel = btn.closest('.tl-panel');
      const willOpen = !panel.classList.contains('is-open');
      panel.closest('[data-tl-accordion]').querySelectorAll('.tl-panel').forEach((p) => setOpen(p, false));
      if (willOpen) setOpen(panel, true);
    });

    // Theme editor: open the panel whose block is selected
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest && event.target.closest('.tl-panel');
      if (!panel) return;
      panel.closest('[data-tl-accordion]').querySelectorAll('.tl-panel').forEach((p) => setOpen(p, p === panel));
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measureAll, 150);
    });
    document.addEventListener('shopify:section:load', measureAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureAll);
    document.querySelectorAll('.tl-panel__image').forEach((img) => {
      if (!img.complete) img.addEventListener('load', measureAll, { once: true });
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measureAll);
    else measureAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
